module.exports = __webpack_public_path__ + "static/media/enoviimaxWhite.1d04c619.svg";